import React, { useState, useEffect, useCallback, useRef } from 'react'
import { Typography, Notification } from '@arco-design/web-react'
import { upDataInfo } from 'api/apis'

const Title = ({ params }) => {
  // 使用 useRef 标记是否为初始加载
  const isInitialLoad = useRef(true)

  // 本地状态
  const [desc, setDesc] = useState(params.desc || params.app_desc || '')
  const [name, setName] = useState(params.name || params.app_name || '')
  const [domain, setDomain] = useState(params.domain || '')
  const [notice_url, setNotice_url] = useState(params.notice_url || '')
  const [record, setRecord] = useState(params)

  // 组件挂载时处理初始数据
  useEffect(() => {
    // 初始化记录状态
    setRecord(params)
    // 设置本地状态
    setName(params.name || params.app_name || '')
    setDesc(params.desc || params.app_desc || '')
    setDomain(params.domain || '')
    setNotice_url(params.notice_url || '')

    // 初始加载完成
    isInitialLoad.current = false
  }, [params])

  // 保存函数，通过失去焦点事件触发
  const handleSave = useCallback(() => {
    // 只有在非初始加载时才执行更新逻辑
    if (isInitialLoad.current) return

    // 检查数据是否有实际变化
    if (
      name === record.name &&
      desc === record.desc &&
      domain === record.domain &&
      notice_url === record.notice_url
    ) {
      return
    }

    let hasError = false

    // 检查标题长度
    if (name && name.length > 10) {
      Notification.warning({ content: '修改标题超过10个字!' })
      hasError = true
      // 恢复原始标题
      setName(record.name)
    }

    // 检查描述长度
    if (desc && desc.length > 32) {
      Notification.warning({ content: '修改内容超过32个字!' })
      hasError = true
      // 恢复原始描述
      setDesc(record.desc)
    }

    if (hasError) return

    // 构建请求参数，包含需要更新的字段
    const requestParams = {
      id: record.show_id,
      name: name,
      desc: desc,
      domain: domain,
      notice_url: notice_url
    }

    upDataInfo(requestParams)
      .then((res) => {
        if (res.code === 200) {
          Notification.success({ content: '更新成功！' })
          // 更新本地record状态
          setRecord((prev) => ({
            ...prev,
            name: name,
            desc: desc,
            domain: domain,
            notice_url: notice_url
          }))
        } else {
          Notification.error({ content: res.msg || '更新失败！' })
          // 更新失败时恢复原始值
          setName(record.name)
          setDesc(record.desc)
          setDomain(record.domain)
          setNotice_url(record.notice_url)
        }
      })
      .catch((error) => {
        Notification.error({ content: '网络错误，请稍后重试！' })
        // 错误时恢复原始值
        setName(record.name)
        setDesc(record.desc)
        setDomain(record.domain)
        setNotice_url(record.notice_url)
      })
  }, [name, desc, domain, notice_url, record, isInitialLoad.current])

  return (
    <>
      <div className="edit-title">
        <div className="Header-init">
          <div className="Header-title">
            <Typography.Paragraph
              className="Header-uptitle"
              editable={{
                onChange: (value) => {
                  setName(value)
                },
                onEnd: handleSave
              }}
            >
              {name}
            </Typography.Paragraph>
          </div>
        </div>
        <div className="Header-upParagraph">
          <Typography.Paragraph
            className="Header-uptitle"
            editable={{
              onChange: (value) => {
                setDesc(value)
              },
              onEnd: handleSave
            }}
          >
            {desc}
          </Typography.Paragraph>
        </div>
        {/* 移除保存按钮，仅通过失去焦点触发保存 */}
      </div>
    </>
  )
}

export default Title
